import React from "react";
import { Carousel } from "react-bootstrap";
import "./Banner.css";
const Banner = () => {
  return (
    <div>
      <Carousel style={{ height: "100vh" }}>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://i.ibb.co/dr54ztJ/banner1.jpg"
            alt="First slide"
          />
          <Carousel.Caption>
            <div style={{ textAlign: "left", paddingBottom: "250px" }}>
              <p>DON'T MISS TODAY'S FEATURED DEALS</p>
              <h2>Amazing Cakes</h2>
              <p>Here to bring your life style to the next level</p>
              <button className="btn1 btn">SHOP NOW</button>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://i.ibb.co/NYmhzYH/banner-2.jpg"
            alt="Second slide"
          />

          <Carousel.Caption>
            <div style={{ textAlign: "right", paddingBottom: "250px" }}>
              <p>DON'T MISS TODAY'S FEATURED DEALS</p>
              <h2>Amazing Cakes</h2>
              <p>Here to bring your life style to the next level</p>
              <button className="btn1 btn">SHOP NOW</button>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Banner;
